import React, { useState } from 'react';
import RevenueList from '../components/RevenueList';
import RevenueForm from '../components/RevenueForm';
import useWindowWidth from '../hooks/useWindowWidth';
import '../components/RevenueDesktop.css';
import '../components/MobileApp.css';

function RevenuesPage() {
  const [editingRevenue, setEditingRevenue] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const width = useWindowWidth();

  const handleEdit = (revenue) => {
    setEditingRevenue(revenue);
    setShowForm(true);
  };

  const handleNewRevenue = () => {
    setEditingRevenue(null);
    setShowForm(true);
  };

  const handleSuccess = () => {
    setShowForm(false);
    setEditingRevenue(null);
    setRefreshTrigger(prev => prev + 1);
  };

  const isDesktop = width >= 768;

  return (
    <div>
      {/* ── Desktop header ── */}
      {isDesktop && !showForm && (
        <div className="rv-page-header">
          <div className="rv-page-header-title">
            <h1>Receitas</h1>
            <p>Gerencie seus recebimentos</p>
          </div>
          <button className="rv-btn rv-btn-success" onClick={handleNewRevenue}>
            + Nova Receita
          </button>
        </div>
      )}

      {/* ── Desktop: form replaces list ── */}
      {isDesktop ? (
        showForm ? (
          <div>
            <p className="rv-form-heading">{editingRevenue ? 'Editar Receita' : 'Nova Receita'}</p>
            <RevenueForm revenue={editingRevenue} onSuccess={handleSuccess} />
            <button className="btn btn-secondary mt-3" onClick={() => setShowForm(false)}>Cancelar</button>
          </div>
        ) : (
          <RevenueList onEdit={handleEdit} refreshTrigger={refreshTrigger} onNewRevenue={handleNewRevenue} />
        )
      ) : (
        /* ── Mobile: lista sempre visível, formulário em bottom sheet ── */
        <>
          <RevenueList onEdit={handleEdit} refreshTrigger={refreshTrigger} onNewRevenue={handleNewRevenue} />
          {showForm && (
            <>
              <div className="mapp-sheet-overlay" onClick={() => setShowForm(false)} />
              <div className="mapp-sheet">
                <div className="mapp-sheet-handle" />
                <div className="mapp-sheet-header">
                  <span className="mapp-sheet-title">
                    {editingRevenue ? 'Editar Receita' : 'Nova Receita'}
                  </span>
                  <button className="mapp-sheet-close" onClick={() => setShowForm(false)}>✕</button>
                </div>
                <div className="mapp-sheet-body">
                  <RevenueForm revenue={editingRevenue} onSuccess={handleSuccess} />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default RevenuesPage;
